const MuiOutlinedInput = {
  styleOverrides: {
    input: {
      padding: 14,
    },
    root: {
      borderRadius: 4,
    },
  },
};

export default MuiOutlinedInput;
